export default __webpack_public_path__ + "static/user-section-image-fa4ce848d161fc87443ad8a41d8b4d06.jpg";